// NAK ゼロベースリデザイン モック共通JS（メニュー・出現アニメ・固定CTA）
(function(){
  // ハンバーガーメニュー
  var btn = document.querySelector('.menu-btn');
  if(btn){
    btn.addEventListener('click', function(){
      var open = document.body.classList.toggle('menu-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.querySelectorAll('.menu-overlay a').forEach(function(a){
      a.addEventListener('click', function(){ document.body.classList.remove('menu-open'); });
    });
  }

  // スクロール出現。.rv のほか、章ラベル・実績帯・全幅写真も個別に監視する
  var TARGETS = '.rv, .sec-head, .stats, .nak-break';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 画面に入っているものを表示する。監視の取りこぼしを拾う役目も兼ねる
  function reveal(ratio){
    document.querySelectorAll(TARGETS).forEach(function(el){
      if(el.classList.contains('in')) return;
      if(el.getBoundingClientRect().top < window.innerHeight * ratio) el.classList.add('in');
    });
  }

  if(!reduce && 'IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, {rootMargin:'0px 0px -10% 0px', threshold:0.05});
    document.querySelectorAll(TARGETS).forEach(function(el){ io.observe(el); });

    // 最初の画面に入っている分は、読み込み直後に順に出す（真っ白な待ち時間を作らない）
    requestAnimationFrame(function(){ reveal(0.92); });

    // 勢いよくスクロールされると監視が追いつかず、真っ暗なまま通り過ぎることがある。
    // スクロールのたびに画面内を見直して、取りこぼしを必ず表示する
    var pending = 0;
    window.addEventListener('scroll', function(){
      if(pending) return;
      pending = setTimeout(function(){ pending = 0; reveal(0.95); }, 100);
    }, {passive:true});
  } else {
    document.querySelectorAll(TARGETS).forEach(function(el){ el.classList.add('in'); });
  }

  // よくある質問：答えの展開／折りたたみ
  document.querySelectorAll('.qa .q').forEach(function(btn){
    btn.addEventListener('click', function(){
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if(!panel) return;
      var open = panel.hasAttribute('hidden');
      if(open){ panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden',''); }
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* 生地一覧：色の展開／折りたたみ

     PCでは一覧が2列なので、片方の生地の色を開くと開いた側だけが縦に伸び、
     反対の列が800px以上まるまる空欄になっていた。
     開いた生地だけ2列ぶち抜き（CSSの .fx-open）にして、空いた場所に拡大写真を置く。
     色見本にマウスを乗せると拡大写真がその色に切り替わる。
     モバイルは1列なので空欄が出ない → 拡大写真は作らず従来どおり。 */
  var fxPC = window.matchMedia('(min-width:1000px)');

  function fxDrive(url, w){
    return /lh3\.googleusercontent\.com/.test(url)
      ? url.replace(/=w\d+(-h\d+)?$/, '') + '=w' + w
      : url;
  }
  function fxId(url){
    var m = (url || '').match(/\/d\/([^=/?]+)/);
    return m ? m[1] : url;
  }

  // 拡大写真の枠を1回だけ作る。初期表示は代表写真とその色名
  function fxBuildPreview(item, panel){
    if(panel.querySelector('.fx-preview')) return;
    var headImg = item.querySelector('.fx-head .ph img');
    if(!headImg) return;

    var box = document.createElement('div');
    box.className = 'fx-preview';
    var img = document.createElement('img');
    img.alt = '';
    img.decoding = 'async';
    var cap = document.createElement('span');
    cap.className = 'cap';
    box.appendChild(img);
    box.appendChild(cap);
    panel.insertBefore(box, panel.firstChild);

    // 代表写真は色見本のどれかと同じ画像なので、IDが一致するものから色名を拾う
    var hid = fxId(headImg.getAttribute('src')), label = '';
    Array.prototype.forEach.call(panel.querySelectorAll('.sw'), function(sw){
      var si = sw.querySelector('img');
      if(!label && si && fxId(si.getAttribute('src')) === hid){
        label = (sw.querySelector('span') || { textContent: '' }).textContent.trim();
      }
    });
    fxShow(box, headImg.getAttribute('src'), label);
  }

  function fxShow(box, url, label){
    var img = box.querySelector('img'), cap = box.querySelector('.cap');
    img.src = fxDrive(url, 900);
    cap.textContent = label || '';
  }

  document.querySelectorAll('.fx-toggle').forEach(function(btn){
    btn.addEventListener('click', function(){
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if(!panel) return;
      var item = btn.closest('.fx-item');
      var open = panel.hasAttribute('hidden');
      if(open){ panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden',''); }
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if(item){
        /* 2列ぶち抜き＋拡大写真にするのは、色数が8色以上のときだけ。
           色見本は6列＝拡大写真の高さ（2行）に4マス×2行が入る。
           8色未満だとその2行が埋まりきらず、暗い空マスが並んでしまう。
           そもそも色数が少ない生地は開いても縦に伸びないので、空欄の問題も起きない。 */
        item.classList.toggle('fx-open', open);
        fxReflow(item);
        if(item.classList.contains('fx-wide') && open) fxBuildPreview(item, panel);
      }
    });
  });

  /* PCで2列ぶち抜きにするかを、色見本と制作事例の**両方**を見て決め直す。
     どちらかが8つ以上開いていれば、その生地だけ横いっぱいに広げる。
     片方だけ見て決めると、色を閉じたときに事例が開いたまま縦長に戻ってしまう。 */
  function fxReflow(item){
    if(!item) return;
    var wide = false;
    if(fxPC.matches){
      var col = item.querySelector('.fx-colors'), wk = item.querySelector('.fx-works');
      if(col && !col.hasAttribute('hidden') && col.querySelectorAll('.sw').length >= 8) wide = true;
      if(wk && !wk.hasAttribute('hidden') && wk.querySelectorAll('.fx-work').length >= 8) wide = true;
    }
    item.classList.toggle('fx-wide', wide);
  }

  /* 制作事例は最初スマホ6件・PC12件までしか出さない（隠すのはCSS側）。
     ここでは「すべて見る」ボタンを、隠れているものがあるときだけ出す。
     ※ 数字を変えるときは nak-theme.css の nth-child と
       scripts/build-fabric-explorer.js の WORKS_SHOWN も揃えること */
  function fxShownLimit(){ return fxPC.matches ? 12 : 6; }

  function fxSyncMore(){
    document.querySelectorAll('.fx-wmore').forEach(function(btn){
      var panel = btn.previousElementSibling;
      if(!panel || !panel.classList.contains('fx-works')) return;
      var n = panel.querySelectorAll('.fx-work').length;
      /* 消す条件は3つ。
         ・事例をまだ開いていない … 開く前から「すべて見る」があると、
           ボタンが3つ隙間なく並んで押し間違える（2026-08-03 NAKさん指摘）
         ・すでに全部出した
         ・そもそも上限に収まっている */
      btn.hidden = panel.hasAttribute('hidden')
                || panel.classList.contains('fx-all')
                || n <= fxShownLimit();
    });
  }
  fxSyncMore();
  if(fxPC.addEventListener) fxPC.addEventListener('change', fxSyncMore);

  document.querySelectorAll('.fx-wmore').forEach(function(btn){
    btn.addEventListener('click', function(){
      var panel = btn.previousElementSibling;
      if(panel) panel.classList.add('fx-all');
      btn.hidden = true;
    });
  });

  // 生地一覧：「この生地の事例」の開閉。中身は事例ページへのリンクなのでJSは開閉だけ
  document.querySelectorAll('.fx-wtoggle').forEach(function(btn){
    btn.addEventListener('click', function(){
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if(!panel) return;
      var open = panel.hasAttribute('hidden');
      if(open){ panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden',''); }
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      fxReflow(btn.closest('.fx-item'));
      fxSyncMore();          // 開いた／閉じたに合わせて「すべて見る」を出し入れする
    });
  });

  /* 和柄を柄（龍・虎・鳳凰）で絞り込む。
     「龍虎」のように名前に複数入るものは data-motif に空白区切りで両方入っていて、
     どちらのボタンでも出る。並び順（龍優先）はそのまま。 */
  document.querySelectorAll('.fx-filter').forEach(function(bar){
    var group = bar.closest('.fx-group');
    if(!group) return;
    var n = group.querySelector('.fx-sec-head .n');
    var items = group.querySelectorAll('.fx-item');
    var btns = bar.querySelectorAll('.fxf');

    bar.addEventListener('click', function(e){
      var btn = e.target.closest('.fxf');
      if(!btn) return;
      var key = btn.getAttribute('data-motif') || '';

      Array.prototype.forEach.call(btns, function(b){
        var on = (b === btn);
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      var shown = 0;
      Array.prototype.forEach.call(items, function(it){
        var v = ' ' + (it.getAttribute('data-motif') || '') + ' ';
        if(!key || v.indexOf(' ' + key + ' ') >= 0){
          it.removeAttribute('hidden');
          shown++;
        }else{
          it.setAttribute('hidden', '');
          // 隠すものが開きっぱなしだと、絞り込みを解いたとき開いた状態で戻ってくる
          var tg = it.querySelector('.fx-toggle');
          if(tg && tg.getAttribute('aria-expanded') === 'true') tg.click();
        }
      });
      if(n) n.textContent = shown + '種';

      /* 絞り込むと一覧が短くなって表示位置が飛ぶので、その区分の先頭に合わせる。
         ただし**状態の復元中は動かさない**。見ていた生地の位置へ戻す処理と
         取り合いになって、明後日の場所に着地する */
      if(window.nakFxRestoring && window.nakFxRestoring()) return;
      var hh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10) || 0;
      window.scrollTo(0, group.getBoundingClientRect().top + window.scrollY - hh - 8);
    });
  });

  /* 探した言葉と生地の情報を、同じ形に揃えてから照合する。
     ここを通さないと、書き方が少し違うだけで0件になる。
     ・全角英数 → 半角、大文字 → 小文字（「ＬＡＭＥ」「Lame」でも当たる）
     ・ひらがな → カタカナ（「えなめる」で「エナメル」に当たる）
     ・空白と中黒を落とす（「ラ・メール」「ラ メール」の書き分けを吸収する）
     **照合する文字はここでしか作らない。** 生成スクリプト側でも正規化すると、
     片方だけ直したときに気づけない */
  function fxNorm(s){
    return String(s || '')
      .replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(c){ return String.fromCharCode(c.charCodeAt(0) - 0xFEE0); })
      .replace(/[ぁ-ゖ]/g, function(c){ return String.fromCharCode(c.charCodeAt(0) + 0x60); })
      .toLowerCase()
      .replace(/[\s　・･,、]/g, '');
  }

  /* ------------------------------------------------------------------
     生地一覧：名前・色で探す（2026-08-05 NAKさん指示）

     149銘柄を上から見ていくのは現実的でない、というのが元の課題。
     照合する文字は各生地の data-search（生地名＋区分＋色名）にある。

     ・柄の絞り込みボタンとは**同時に効かせない。** 後から使ったほうが勝つ。
       2つの条件が同時にかかると、0件になった理由が分からなくなる
     ・区分（生地／和柄・金襴／装飾）ごと該当が無ければ、見出しごと隠す
     ・開いている色や事例は閉じない。探し直すと元の状態で戻ってくる
     ------------------------------------------------------------------ */
  (function(){
    var box = document.querySelector('.fx-search');
    if(!box) return;
    var input = box.querySelector('input'),
        clear = box.querySelector('.fx-qx'),
        out   = box.querySelector('.fx-qr');
    if(!input || !clear || !out) return;

    // 149銘柄ぶんの照合用の文字は、打つたびに作り直さず最初に1回だけ用意する
    var groups = Array.prototype.map.call(document.querySelectorAll('.fx-group'), function(g){
      return {
        el: g,
        n: g.querySelector('.fx-sec-head .n'),
        items: Array.prototype.map.call(g.querySelectorAll('.fx-item'), function(it){
          return { el: it, s: fxNorm(it.getAttribute('data-search') || '') };
        })
      };
    });

    // 探すのをやめたときの状態に戻す（全部出す・件数を元に戻す）
    function reset(){
      groups.forEach(function(g){
        g.el.removeAttribute('hidden');
        g.items.forEach(function(o){ o.el.removeAttribute('hidden'); });
        if(g.n) g.n.textContent = (g.n.getAttribute('data-all') || g.items.length) + '種';
      });
      out.hidden = true;
      out.classList.remove('none');
    }

    function run(){
      clear.hidden = !input.value;
      var q = fxNorm(input.value);
      if(!q){ reset(); return; }

      // 押されている柄のボタンは「すべて」に戻す（同時に効かせない）
      document.querySelectorAll('.fx-filter .fxf').forEach(function(b){
        var on = !b.getAttribute('data-motif');
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      var total = 0;
      groups.forEach(function(g){
        var k = 0;
        g.items.forEach(function(o){
          if(o.s.indexOf(q) >= 0){ o.el.removeAttribute('hidden'); k++; }
          else { o.el.setAttribute('hidden', ''); }
        });
        if(k) g.el.removeAttribute('hidden'); else g.el.setAttribute('hidden', '');
        if(g.n) g.n.textContent = k + '種';
        total += k;
        /* 出現アニメは画面に入った時点で解除される。
           絞り込みで下の区分が上に来ると解除されないまま薄い状態で止まるので、
           探している間は最初から見えている扱いにする */
        var l = g.el.querySelector('.fx-list');
        if(l) l.classList.add('in');
      });

      out.hidden = false;
      out.classList.toggle('none', total === 0);
      /* 入れているのは固定の文言と件数だけ。**打った言葉をそのまま差し込まないこと** */
      out.innerHTML = total
        ? '<b>' + total + '</b> 種 見つかりました'
        : '見つかりませんでした。生地名・柄・色のどれかで、別の言い方をお試しください（例：エナメル／金襴／龍／黒）';
    }

    /* 日本語入力の変換中は照合しない（2026-08-05）。
       「きんらん」→「金襴」と変換する途中の、ひらがなだけの状態でも
       打つたびに動いてしまい、**変換し終える前に「見つかりませんでした」が出る。**
       確定した時点（compositionend）で照合し直す。 */
    input.addEventListener('input', function(e){
      if(e.isComposing) return;
      run();
    });
    input.addEventListener('compositionend', run);
    input.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && input.value){ input.value = ''; run(); }
    });
    clear.addEventListener('click', function(){ input.value = ''; run(); input.focus(); });

    /* 柄で絞り込んだら、探している言葉のほうを解除する。
       **捕捉フェーズで受けること。** 絞り込み本体より先に走らせないと、
       こちらの「全部出す」が後から効いて絞り込みを打ち消してしまう */
    document.querySelectorAll('.fx-filter').forEach(function(bar){
      bar.addEventListener('click', function(e){
        if(!e.target.closest || !e.target.closest('.fxf') || !input.value) return;
        input.value = '';
        clear.hidden = true;
        reset();
      }, true);
    });

    // 制作事例から戻ってきたときに、探していた言葉を復元するための入口
    window.nakFxSearch = function(v){
      input.value = v || '';
      run();
    };
    // 色で絞り込むほうから「検索を解除して」と言われたときの入口
    window.nakFxClearSearch = function(){
      if(!input.value) return;
      input.value = '';
      clear.hidden = true;
      reset();
    };
  })();

  /* ------------------------------------------------------------------
     生地一覧：色で絞り込む（2026-08-07 NAKさん指示）

     ・**1つの生地は複数の色に出る。** エナメルは20色あるのでほぼ全部に出る。
       これは仕様。「赤の生地」ではなく「赤がある生地」を探している
     ・検索窓・柄の絞り込みとは**同時に効かせない。** 後から使ったほうが勝つ
     ・該当が無い区分は見出しごと隠す（検索と同じ振る舞い）
     ------------------------------------------------------------------ */
  (function(){
    var bar = document.querySelector('.fx-cf');
    if(!bar) return;
    var btns = bar.querySelectorAll('.fxf');
    var copyBtn = document.querySelector('.fx-copy');   // 下でも使うので先に取る
    /* 生地ごとに「元の見え方」を控えておく。
       色で絞ったときは**その色の写真・色数・色見本だけに差し替える**が、
       解除したら元に戻せないといけない（2026-08-07 NAKさん指摘）。 */
    function snap(it){
      var head = it.querySelector('.fx-head .ph img');
      var cnt  = it.querySelector('.fx-head .cnt');
      var lbl  = it.querySelector('.fx-toggle .lbl');
      var chips= it.querySelector('.fx-chips');
      return {
        el: it,
        c: ' ' + (it.getAttribute('data-colors') || '') + ' ',
        head: head, headSrc: head ? head.getAttribute('src') : null,
        cnt: cnt, cntText: cnt ? cnt.textContent : null,
        lbl: lbl, lblText: lbl ? lbl.textContent : null,
        chips: chips, chipsHTML: chips ? chips.innerHTML : null,
        sws: Array.prototype.slice.call(it.querySelectorAll('.fx-colors .sw'))
      };
    }
    var groups = Array.prototype.map.call(document.querySelectorAll('.fx-group'), function(g){
      return {
        el: g,
        n: g.querySelector('.fx-sec-head .n'),
        items: Array.prototype.map.call(g.querySelectorAll('.fx-item'), snap)
      };
    });

    var CHIPS = 6;   // 「色を見る」の横に出す色チップの枚数。生成側と揃えること

    /* その生地を「その色だけ」の見え方にする。key が空なら元に戻す */
    function paint(o, key){
      if(!o.sws.length) return;                      // 1色しかない生地は何もしない
      if(!key){
        o.sws.forEach(function(s){ s.removeAttribute('hidden'); });
        if(o.head && o.headSrc) o.head.setAttribute('src', o.headSrc);
        if(o.cnt) o.cnt.textContent = o.cntText;
        if(o.lbl) o.lbl.textContent = o.lblText;
        if(o.chips) o.chips.innerHTML = o.chipsHTML;
        return;
      }
      var hit = [];
      o.sws.forEach(function(s){
        if(s.getAttribute('data-c') === key){ s.removeAttribute('hidden'); hit.push(s); }
        else s.setAttribute('hidden', '');
      });
      if(!hit.length) return;
      // 代表写真を、その色の1枚目に差し替える（一覧で色が分かるようにする）
      var img = hit[0].querySelector('img');
      if(o.head && img) o.head.setAttribute('src', img.getAttribute('src').replace(/=w\d+$/, '=w500'));
      if(o.cnt) o.cnt.textContent = key + hit.length + '色';
      if(o.lbl) o.lbl.textContent = '色を見る（' + hit.length + '色）';
      if(o.chips){
        var h = '';
        hit.slice(0, CHIPS).forEach(function(s){
          var i = s.querySelector('img');
          h += '<img src="' + i.getAttribute('src').replace(/=w\d+$/, '=w48') + '" alt="" loading="lazy" decoding="async">';
        });
        if(hit.length > CHIPS) h += '<span class="more">+' + (hit.length - CHIPS) + '</span>';
        o.chips.innerHTML = h;
      }
    }

    function apply(key){
      Array.prototype.forEach.call(btns, function(b){
        var on = (b.getAttribute('data-color') || '') === key;
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      groups.forEach(function(g){
        var k = 0;
        g.items.forEach(function(o){
          if(!key || o.c.indexOf(' ' + key + ' ') >= 0){
            o.el.removeAttribute('hidden');
            paint(o, key);          // その色だけの見え方にする（解除なら元に戻す）
            k++;
          }
          else { o.el.setAttribute('hidden', ''); paint(o, ''); }
        });
        if(k) g.el.removeAttribute('hidden'); else g.el.setAttribute('hidden', '');
        if(g.n) g.n.textContent = key ? (k + '種') : ((g.n.getAttribute('data-all') || g.items.length) + '種');
        /* 出現アニメは画面に入った時点で解除される。絞り込みで下の区分が上に来ると
           解除されないまま薄いままになるので、絞っている間は見えている扱いにする */
        var l = g.el.querySelector('.fx-list');
        if(l) l.classList.add('in');
      });
    }

    /* 絞り込んだ状態をURLに残す（2026-08-07 NAKさん要望）。
       **お客様にリンクを送るためのもの。** /pages/fabrics?color=brown で開くと茶で絞られた状態になる。
       ・replaceState を使う。pushState にすると、色を押すたびに「戻る」が増えて戻れなくなる
       ・日本語ではなく black / brown などの英字キーを使う（LINEで送ったときに読める形にする）
       ・Shopifyのページキャッシュは付けた ?color= を無視するので、配信には影響しない
         （絞り込みはブラウザ側でやっているため） */
    function syncUrl(key){
      if(!window.history || !history.replaceState) return;
      var b = key ? bar.querySelector('.fxf[data-color="' + key + '"]') : null;
      var k = b ? b.getAttribute('data-key') : '';
      var u = location.pathname + (k ? '?color=' + k : '') + location.hash;
      history.replaceState(null, '', u);
      if(copyBtn) copyBtn.hidden = !k;
    }

    bar.addEventListener('click', function(e){
      var b = e.target.closest && e.target.closest('.fxf');
      if(!b) return;
      syncUrl(b.getAttribute('data-color') || '');
      // 検索と柄の絞り込みは解除する（同時に効かせない）
      if(window.nakFxClearSearch) window.nakFxClearSearch();
      document.querySelectorAll('.fx-filter:not(.fx-cf) .fxf').forEach(function(m){
        var on = !m.getAttribute('data-motif');
        m.classList.toggle('on', on);
        m.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      apply(b.getAttribute('data-color') || '');
    });

    /* 検索窓・柄の絞り込みが使われたら、色のほうは「すべて」に戻す。
       **捕捉フェーズで受けること。** 本体より先に走らせないと、
       こちらの表示し直しが後から効いて絞り込みを打ち消してしまう */
    function releaseColor(){
      var on = bar.querySelector('.fxf.on');
      if(!on || !on.getAttribute('data-color')) return;   // すでに「すべて」なら何もしない
      /* **ボタンの見た目だけ戻すのでは足りない。**
         柄の絞り込みは自分の区分の中しか計算し直さないので、
         色で隠した他の区分の生地が隠れたまま残る（2026-08-07に実際に出た）。
         ここで全部出しきってから、後続の絞り込みに計算させる。 */
      apply('');
      syncUrl('');   // **URLからも ?color= を外す。** 残すと、検索中のリンクを送ったのに色で開く
    }
    document.querySelectorAll('.fx-filter:not(.fx-cf)').forEach(function(m){
      m.addEventListener('click', function(e){
        if(e.target.closest && e.target.closest('.fxf')) releaseColor();
      }, true);
    });
    var qi = document.querySelector('.fx-search input');
    if(qi) qi.addEventListener('input', releaseColor, true);

    /* 「このリンクをコピー」。色で絞っているときだけ出す。
       スマホでアドレスバーからURLを拾うのは面倒なので、1タップで取れるようにする */
    if(copyBtn){
      copyBtn.addEventListener('click', function(){
        var url = location.href;
        function done(){
          var t = copyBtn.textContent;
          copyBtn.textContent = 'コピーしました';
          setTimeout(function(){ copyBtn.textContent = t; }, 1800);
        }
        if(navigator.clipboard && navigator.clipboard.writeText){
          navigator.clipboard.writeText(url).then(done, function(){});
        }else{
          // 古い端末向け。一時的な入力欄を作って選択・コピーする
          var t = document.createElement('textarea');
          t.value = url; t.setAttribute('readonly',''); t.style.position='fixed'; t.style.opacity='0';
          document.body.appendChild(t); t.select();
          try{ document.execCommand('copy'); done(); }catch(e){}
          document.body.removeChild(t);
        }
      });
    }

    /* 開いたときに ?color= があれば、その色で絞った状態から始める。
       送られたリンクを開いた人が、押し直さなくていいようにするため */
    (function(){
      var m = (location.search || '').match(/[?&]color=([a-z]+)/);
      if(!m) return;
      var b = bar.querySelector('.fxf[data-key="' + m[1] + '"]');
      if(!b) return;                       // 知らないキーなら何もしない（全部表示のまま）
      apply(b.getAttribute('data-color'));
      if(copyBtn) copyBtn.hidden = false;
    })();
  })();

  // 色見本にマウスを乗せる／キーボードで移動すると、拡大写真が切り替わる
  document.addEventListener('mouseover', function(e){
    if(!e.target.closest || !fxPC.matches) return;
    var sw = e.target.closest('.fx-item.fx-wide .fx-colors .sw');
    if(!sw) return;
    var box = sw.parentNode.querySelector('.fx-preview');
    var img = sw.querySelector('img');
    if(!box || !img) return;
    fxShow(box, img.getAttribute('src'), (sw.querySelector('span') || { textContent: '' }).textContent.trim());
  });

  /* 動画（代表の想いなど）を、画面に入ったら音を消して自動再生する（2026-08-03）

     ・音を出したい人は、そのまま再生バーの音量ボタンを押せばよい
       （ブラウザは音の出る動画を勝手に再生させないので、始まりは必ず無音）
     ・**画面に入るまで動画を取りに行かない。** この動画は26.7MBある。
       全員に最初から読ませると本文の読み込みと帯域を取り合い、
       下まで見ない人のギガも使ってしまう
     ・画面から出たら止める。**音を出したまま裏で流れ続けるのを防ぐ**ので、
       ここは自分で再生した人にも効かせる
     ・ただし**自分で止めた人には手を出さない**。
       止めたのに画面に入るたび再生される、が一番うるさい。
       音量ボタンを押しただけの人は「止めた」ではないので、自動再生は続ける */
  var autoVideos = document.querySelectorAll('video[data-autoplay]');
  if(autoVideos.length && 'IntersectionObserver' in window){
    /* 「自分で操作したか」の見分け方に注意。
       play / pause は**こちらから呼んでも本物のイベントとして飛んでくる**ので、
       e.isTrusted では区別できない。自動でいじっている間だけ印を立てて、
       その間のイベントは自分の操作とみなさない。 */
    function auto(v, fn){
      v.__nakAuto = true;
      try{ fn(); }catch(e){}
      setTimeout(function(){ v.__nakAuto = false; }, 60);
    }

    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        var v = en.target;
        if(en.isIntersecting){
          if(v.__nakStopped) return;              // 自分で止めた人にはさわらない
          if(v.preload !== 'auto') v.preload = 'auto';
          auto(v, function(){
            var p = v.play();
            if(p && p.catch) p.catch(function(){ /* 拒否されたら静かに諦める */ });
          });
        }else if(!v.paused){
          auto(v, function(){ v.pause(); });      // 音が裏で流れ続けないよう、こちらは常に効かせる
        }
      });
    }, { threshold: 0.35 });

    Array.prototype.forEach.call(autoVideos, function(v){
      // 自分で止めた／自分で再生した、だけを覚える。音量の上げ下げは「止めた」に含めない
      v.addEventListener('pause', function(){ if(!v.__nakAuto) v.__nakStopped = true; });
      v.addEventListener('play',  function(){ if(!v.__nakAuto) v.__nakStopped = false; });
      io.observe(v);
    });
  }

  // 保険：何らかの理由で出現アニメが動かなくても、2秒後には画面内のものを必ず表示する
  setTimeout(function(){ reveal(1); }, 2000);

  // 簡易見積もり（オーダーTシャツ）：選ぶとその場で合計を出す
  // 金額はすべてliquid側のdata属性から受け取る。ここに数字は書かない（価格改定はテーマエディタで完結させるため）
  document.querySelectorAll('[data-quote]').forEach(function(box){
    var num   = box.querySelector('.q-num');
    var pants = box.querySelector('.q-pants');
    var maxQ  = parseInt(box.dataset.max, 10) || 200;
    var yen   = function(n){ return '¥' + Math.round(n).toLocaleString('ja-JP'); };
    var out   = function(k){ return box.querySelector('[data-out="' + k + '"]'); };
    /* ポロシャツのボタンは 2026-10-02 に外した（注釈だけ残している）。
       そのため半袖・長袖の切り替えを止める処理（syncPolo）も外した */

    function unitPrice(){
      var sleeve = box.querySelector('input[name^="q-sleeve"]:checked');
      var side   = box.querySelector('input[name^="q-side"]:checked');
      var s = sleeve ? sleeve.value : 's';
      var f = side   ? side.value   : 'f';
      return parseInt(box.dataset[(s === 's' ? 's' : 'l') + (f === 'f' ? 'f' : 'b')], 10) || 0;
    }

    /* 袖へのプリント（2026-10-02 追加）。右袖・左袖それぞれ、1枚あたり data-sleeve 円を足す */
    function arms(){
      var names = [];
      box.querySelectorAll('.q-arm:checked').forEach(function(c){ names.push(c.value === 'r' ? '右袖' : '左袖'); });
      return names;
    }

    function run(){
      // 枚数は 1〜最大 の範囲に収める。空欄のときは1枚として計算する
      var q = parseInt(num.value, 10);
      if(isNaN(q) || q < 1) q = 1;
      if(q > maxQ) { q = maxQ; num.value = maxQ; }

      var unit   = unitPrice();
      var shirts = unit * q;
      var armList = arms();
      var armUnit = parseInt(box.dataset.sleeve, 10) || 0;
      var armSum  = armUnit * armList.length * q;
      var design = parseInt(pants && pants.checked ? box.dataset.dwith : box.dataset.donly, 10) || 0;
      var total  = shirts + armSum + design;

      out('shirts').textContent = yen(unit) + ' × ' + q + '枚 ＝ ' + yen(shirts);
      var armLine = out('arm-line');
      if(armLine){
        armLine.hidden = !armList.length;
        // どちらの袖かはボタンで分かるので、スマホで折り返さないよう見出しは短くする
        out('arm-label').textContent = '袖プリント';
        out('arm').textContent = yen(armUnit) + ' × ' + armList.length + 'か所 × ' + q + '枚 ＝ ' + yen(armSum);
      }
      out('design-label').textContent = 'デザイン費'
        + (pants && pants.checked ? '（キックパンツと同時）' : '（Tシャツだけ）');
      out('design').textContent = yen(design);
      out('total').textContent  = yen(total);
      /* 「1枚あたり」はやめた（2026-09-08 NAKさん指示）。
         合計をそのまま枚数で割ると、1回だけのデザイン費が1枚ずつに乗った金額になり、
         Tシャツ1枚が¥4,500なのに「1枚あたり¥6,167」と見えてしまうため。 */

      // 選択中の見た目。CSSの :has() が使えない端末でも分かるように、ここでも印を付ける
      box.querySelectorAll('.q-opt').forEach(function(lab){
        var input = lab.querySelector('input');
        lab.classList.toggle('on', !!(input && input.checked));
      });
    }

    box.addEventListener('change', run);
    num.addEventListener('input', run);

    // 入力中は数字を書き換えない（「5」を消して「10」と打ち直せなくなるため）。
    // 欄から離れたときだけ、計算に使った枚数に揃える
    num.addEventListener('blur', function(){
      var q = parseInt(num.value, 10);
      if(isNaN(q) || q < 1) q = 1;
      if(q > maxQ) q = maxQ;
      num.value = q;
      run();
    });
    box.querySelectorAll('.q-step').forEach(function(btn){
      btn.addEventListener('click', function(){
        var q = parseInt(num.value, 10);
        if(isNaN(q)) q = 1;
        q += parseInt(btn.dataset.step, 10);
        num.value = Math.min(maxQ, Math.max(1, q));
        run();
      });
    });
    run();
  });

  // カートの個数。ページがキャッシュされていると liquid で出した数字が古いままになるので、
  // 表示したあとに実際のカートを見に行って上書きする（0なら出さない）
  var cartCount = document.querySelector('[data-cart-count]');
  if(cartCount){
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(c){
        if(!c) return;
        var n = c.item_count || 0;
        cartCount.textContent = n;
        cartCount.hidden = (n === 0);
      })
      .catch(function(){ /* 取れなければ liquid が出した数字のままにする */ });
  }
  // 固定ボトムCTA（ヒーローを過ぎたら表示・フッター付近で隠す）
  var bar = document.querySelector('.sticky-cta');
  if(bar){
    var footer = document.querySelector('footer');
    window.addEventListener('scroll', function(){
      var y = window.scrollY;
      var nearFooter = footer && (y + window.innerHeight > footer.offsetTop + 120);
      bar.classList.toggle('show', y > 500 && !nearFooter);
    }, {passive:true});
  }
})();

/* 写真の拡大表示（ライトボックス）
   ------------------------------------------------------------------
   2つの場所で使っている。**中身は共通、入り口だけ違う。**

   1) 製作事例（/pages/works）
      カードをタップ → その一本の写真を全部めくれる。
      写真の一覧は #works-media のJSON、カードの data-w がその添字。
      （生成は scripts/works-attach-photos.js。手で書き換えないこと）
      <a href="/products/…"> のままにしてある。JSが横取りするので通常のクリックでは
      ページ移動しないが、新しいタブで開いた人・JSが動かない人は商品ページに着く。

   2) 生地一覧（/pages/fabrics）※2026-08-02 追加
      生地の写真か色見本をタップ → その生地の全色を大きく見られる。
      一覧に既に入っている画像URLを使う（別データを持たない）。

   list の中身は {big, thumb, label} の配列。
   **URLの作り方が場所ごとに違う**（Shopifyは ?width=、Googleドライブは =w）ので、
   入り口側で完成したURLを渡す形にしてある。
   写真は開いたときに初めて読み込む（先読みすると重い）。
   ------------------------------------------------------------------ */
(function(){
  var tag = document.getElementById('works-media');
  var hasWorks = tag && document.querySelector('.works-grid .work-card[data-w]');
  var hasFabric = document.querySelector('.fx-item');
  /* お客様の声（/pages/reviews）。写真のあるカードだけを対象にする。
     トップページの声は写真の入れ方が違う（.who .thumb）ので、ここには当たらない */
  var hasReviews = document.querySelector('.review-cards .review-card .rv-photo img');
  /* トップ・フルオーダーLP等に置いている抜粋グリッド（sections/nak-works.liquid）。
     2026-09-03 まではカードを押すと商品ページへ飛んでいたが、製作事例ページと
     挙動を揃えて**その場で拡大**する。写真一覧はセクションごとのJSONに入っている。 */
  var hasMini = document.querySelector('.works-grid[data-media] .work-card[data-m]');
  /* トップ・フルオーダー・セミオーダー等の「お客様の声」の抜粋カード（.rv-teaser）の写真（2026-10-22 追加） */
  var hasTeaser = document.querySelector('.rv-teaser .review-card .who .thumb img');
  if(!hasWorks && !hasFabric && !hasReviews && !hasMini && !hasTeaser) return;   // どれでもないページでは何もしない

  var data = null;
  if(hasWorks){
    try { data = JSON.parse(tag.textContent); } catch(e){ data = null; }
    if(!data || !data.items) hasWorks = false;
  }

  var W = '?width=1400';                    // 拡大表示に必要な解像度。元画像を丸ごと出すと重い
  var TW = '?width=160';                    // サムネイル用。52〜62pxで出すので160pxあれば足りる
  var box, imgEl, capNm, capMt, countEl, prevBtn, nextBtn, thumbsEl, rvwSt, rvwTx, moreEl;
  var list = [], at = 0, opener = null, metaFallback = '', mode = 'photo';
  /* 開いている事例の識別子。**表示名ではなく商品ハンドルで数える。**
     同じ選手の2本目・3本目が同じ名前で混ざってしまうため（2026-09-03） */
  var curId = '';

  function build(){
    box = document.createElement('div');
    box.className = 'wlb';
    box.setAttribute('role','dialog');
    box.setAttribute('aria-modal','true');
    box.setAttribute('aria-label','製作事例の写真');
    box.innerHTML =
      '<div class="wlb-top">'
    +   '<span class="wlb-count"></span>'
    +   '<button class="wlb-close" type="button" aria-label="閉じる">✕</button>'
    + '</div>'
    + '<div class="wlb-stage">'
    +   '<button class="wlb-nav wlb-prev" type="button" aria-label="前の写真">‹</button>'
    +   '<img alt="">'
    +   '<button class="wlb-nav wlb-next" type="button" aria-label="次の写真">›</button>'
    + '</div>'
    /* レビューを開いたときだけ出る欄（星とコメント）。
       写真の下、名前の上に置く。読む順が「写真 → 感想 → 誰の声か」になる */
    + '<div class="wlb-cap">'
    +   '<div class="rvw"><div class="st" aria-hidden="true"></div><p class="tx"></p></div>'
    +   '<div class="nm"></div><div class="mt"></div>'
    /* 押す既定の動きは「拡大」にしたので、仕様や生地を読みたい人の道をここに残す。
       レビューには出さない（商品ページが無いため） */
    +   '<a class="wlb-more" href="#" hidden>この一本の詳細を見る →</a>'
    + '</div>'
    + '<div class="wlb-thumbs"></div>';
    document.body.appendChild(box);

    imgEl   = box.querySelector('.wlb-stage img');
    capNm   = box.querySelector('.wlb-cap .nm');
    capMt   = box.querySelector('.wlb-cap .mt');
    thumbsEl= box.querySelector('.wlb-thumbs');
    rvwSt   = box.querySelector('.wlb-cap .rvw .st');
    rvwTx   = box.querySelector('.wlb-cap .rvw .tx');
    moreEl  = box.querySelector('.wlb-more');
    countEl = box.querySelector('.wlb-count');
    prevBtn = box.querySelector('.wlb-prev');
    nextBtn = box.querySelector('.wlb-next');

    box.querySelector('.wlb-close').addEventListener('click', close);
    prevBtn.addEventListener('click', function(){ go(-1); });
    nextBtn.addEventListener('click', function(){ go(1); });
    // 背景（写真そのもの以外）を押したら閉じる
    box.addEventListener('click', function(e){
      if(e.target === box || e.target.classList.contains('wlb-stage')) close();
    });
    imgEl.addEventListener('load', function(){ imgEl.classList.remove('loading'); });

    // スワイプ。縦スクロールと取り違えないよう、横の動きが縦より大きいときだけ反応する
    var sx = 0, sy = 0, tracking = false;
    box.addEventListener('touchstart', function(e){
      if(e.touches.length !== 1) return;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true;
    }, {passive:true});
    box.addEventListener('touchend', function(e){
      if(!tracking) return;
      tracking = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - sx, dy = t.clientY - sy;
      if(Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
    }, {passive:true});
  }

  /* 下にサムネイルを並べる。
     矢印だけでは「他に写真がある」こと自体が伝わらなかったため、実物を見せる。
     サムネイルは開いた事例ごとに作り直す（97件分を先に作ると無駄が大きい） */
  function buildThumbs(){
    thumbsEl.innerHTML = '';
    if(list.length < 2) return;
    list.forEach(function(f, i){
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', f.label || ((i + 1) + '枚目の写真'));
      var im = document.createElement('img');
      im.src = f.thumb;
      im.alt = '';
      im.loading = 'lazy';
      im.decoding = 'async';
      b.appendChild(im);
      b.addEventListener('click', function(){ if(i !== at){ at = i; show(); } });
      thumbsEl.appendChild(b);
    });
  }

  /* 今見ている写真のサムネイルを、帯の真ん中に寄せる。
     scrollIntoView は使わないこと。ページ全体が動くことがある */
  function syncThumbs(){
    var kids = thumbsEl.children;
    for(var i = 0; i < kids.length; i++) kids[i].classList.toggle('on', i === at);
    var t = kids[at];
    if(t) thumbsEl.scrollLeft = t.offsetLeft - (thumbsEl.clientWidth - t.offsetWidth) / 2;
  }

  /* --- 計測（GA4）---
     どの一本が見られていて、写真をめくってもらえているかを知るため。
     イベント名と項目名は scripts/ga4-works-photos.js が読む。**変えたら両方直すこと。**

     work_photo_open … 拡大表示を開いた（work_name, photo_count）
     work_photo_view … 実際に見た写真1枚ごと（work_name, photo_index）
                       1回開いている間の重複は数えない。
                       「開いた数」と「見た枚数」を割れば、めくってもらえた枚数が出る

     ※ GA4は項目（work_name等）を「カスタムディメンション」に登録しないと
       レポートに出てこない。登録は管理画面での操作が必要（APIからはできない） */
  /* /products/xxxx?variant=1#a → xxxx を取り出す。
     商品ページ以外（/pages/full-order 等）や空のときは '' を返す */
  function handleOf(href){
    if(!href || href.indexOf('/products/') < 0) return '';
    return href.split('/products/')[1].split('?')[0].split('#')[0].split('/')[0];
  }

  var seen = {};   // 1回開いている間に見た写真。重複計上を防ぐ
  function track(name, params){
    if(typeof gtag !== 'function') return;
    try { gtag('event', name, params); } catch(e){ /* 計測は失敗しても表示に影響させない */ }
  }

  function show(){
    imgEl.classList.add('loading');
    imgEl.src = list[at].big;
    countEl.textContent = (at + 1) + ' / ' + list.length;
    prevBtn.disabled = (at === 0);
    nextBtn.disabled = (at === list.length - 1);
    // 生地は写真ごとに色名が変わる。製作事例は仕様が固定なので、そのまま出す
    capMt.textContent = list[at].label || metaFallback;
    /* レビューは1件ごとに書いた人もコメントも違う。めくるたびに入れ替える */
    if(list[at].nm != null) capNm.textContent = list[at].nm;
    if(rvwTx){
      rvwTx.textContent = list[at].review || '';
      rvwSt.textContent = list[at].stars || '';
      rvwTx.parentNode.scrollTop = 0;   // 長い声のあと短い声に移ると、途中から始まって見える
    }
    syncThumbs();
    if(!seen[at]){
      seen[at] = 1;
      if(mode === 'review' || mode === 'rvphoto'){
        track('review_photo_view', { work_name: capNm.textContent, photo_index: at + 1 });
      } else if(mode === 'fabric'){
        /* 生地の拡大は製作事例と分けて数える。混ざると事例の順位計算が狂う
           （8/1〜9/2 は生地1,176回・事例482回が同じ名前で入っていた） */
        track('fabric_photo_view', { fabric_name: capNm.textContent, photo_index: at + 1 });
      } else {
        track('work_photo_view', { work_id: curId, work_name: capNm.textContent, photo_index: at + 1 });
      }
    }
    // 隣の写真を先に取っておくと、めくったときに待たされない
    [at - 1, at + 1].forEach(function(i){
      if(i >= 0 && i < list.length){ var p = new Image(); p.src = list[i].big; }
    });
  }
  function go(d){
    var next = at + d;
    if(next < 0 || next >= list.length) return;
    at = next; show();
  }
  function close(){
    box.classList.remove('open');
    document.body.classList.remove('wlb-open');
    document.removeEventListener('keydown', onKey);
    if(opener) opener.focus();
    // 閉じたあとに写真を持ち続けない
    setTimeout(function(){ if(!box.classList.contains('open')) imgEl.removeAttribute('src'); }, 300);
  }
  function onKey(e){
    if(e.key === 'Escape') close();
    else if(e.key === 'ArrowLeft') go(-1);
    else if(e.key === 'ArrowRight') go(1);
  }

  /* 共通の入り口。
     items … [{big, thumb, label}] の配列（URLは完成済みで渡すこと）
     start … 最初に見せる番号
     name  … 見出し（選手名・生地名）
     meta  … 見出しの下（仕様。生地は色名を写真ごとに出すので空でよい） */
  function openWith(items, start, name, meta, from, kind, id, href){
    if(!items || !items.length) return false;
    if(!box) build();
    mode = kind || 'photo';
    curId = id || '';
    /* 'review' のときだけ、CSS側でコメント欄を出して写真を少し小さくする */
    box.setAttribute('data-mode', mode);
    box.setAttribute('aria-label', mode === 'review' ? 'お客様の声' : (mode === 'rvphoto' ? 'お客様の写真' : '製作事例の写真'));
    list = items;
    at = Math.max(0, Math.min(start || 0, list.length - 1));
    opener = from || null;
    metaFallback = meta || '';
    box.setAttribute('data-single', list.length > 1 ? '0' : '1');
    capNm.textContent = name || '';
    /* 商品ページへの道。URLが無いとき・レビューのときは出さない */
    if(moreEl){
      if(href && mode !== 'review' && mode !== 'rvphoto'){ moreEl.href = href; moreEl.hidden = false; }
      else { moreEl.removeAttribute('href'); moreEl.hidden = true; }
    }
    seen = {};       // 開くたびに数え直す
    buildThumbs();   // show() より先。show() の中でサムネイルの位置を合わせるため
    if(mode === 'review' || mode === 'rvphoto'){
      track('review_photo_open', { work_name: name || '', photo_count: list.length });
    } else if(mode === 'fabric'){
      track('fabric_photo_open', { fabric_name: name || '', photo_count: list.length });
    } else {
      track('work_photo_open', { work_id: curId, work_name: name || '', photo_count: list.length });
    }
    show();
    box.classList.add('open');
    document.body.classList.add('wlb-open');
    document.addEventListener('keydown', onKey);
    box.querySelector('.wlb-close').focus();
    return true;
  }

  /* ---- 入り口1：製作事例 ---- */
  if(hasWorks){
    // カードは97枚あるので、1枚ずつではなくグリッドでまとめて受ける
    document.addEventListener('click', function(e){
      var card = e.target.closest ? e.target.closest('.work-card[data-w]') : null;
      if(!card) return;
      // 新しいタブで開こうとしている人の邪魔をしない
      if(e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      var files = data.items[parseInt(card.getAttribute('data-w'), 10)] || [];
      var items = files.map(function(f){
        return { big: data.base + f + W, thumb: data.base + f + TW, label: '' };
      });
      var nm = card.querySelector('.name'), mt = card.querySelector('.meta');
      /* 商品に紐づいていないカード（href が /pages/full-order のまま。5件ある）には
         「この一本の詳細を見る」を出さない。行き先が商品ページではないため */
      var href = card.getAttribute('href') || '', pid = handleOf(href);
      if(openWith(items, 0, nm ? nm.textContent.trim() : '', mt ? mt.textContent.trim() : '',
                  card, 'works', pid, pid ? href : '')) {
        e.preventDefault();
      }
    });
  }

  /* ---- 入り口2：生地一覧（2026-08-02 追加） ----
     一覧に並んでいる生地をタップしても何も起きなかった、というNAKさんの指摘への対応。

     写真は一覧のHTMLに既に入っているので、別データを作らない。
     GoogleドライブのURLは末尾の =w500 / =w300 を差し替えるだけで大きい版が取れる。

     色見本そのものをタップしたときは、その色から開く。
     ※ 代表写真は色見本のどれかと同じ画像のことがある（例：エナメルの代表写真＝黒）。
       同じ画像を2回出さないよう、IDで重複を除いている。 */
  if(hasFabric){
    function driveSize(url, w){
      return /lh3\.googleusercontent\.com/.test(url)
        ? url.replace(/=w\d+(-h\d+)?$/, '') + '=w' + w
        : url;
    }
    function driveId(url){
      var m = url.match(/\/d\/([^=/?]+)/);
      return m ? m[1] : url;
    }
    document.addEventListener('click', function(e){
      if(!e.target.closest) return;
      /* 開閉ボタンと、制作事例のリンクは邪魔しない。
         **fx-work を外すと、事例をタップしても商品ページへ行かず
         拡大表示が開いてしまう。**（.fx-item の中にあるため） */
      if(e.target.closest('.fx-toggle, .fx-wtoggle, .fx-work')) return;
      var item = e.target.closest('.fx-item');
      if(!item) return;
      if(e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;

      var name = (item.querySelector('.nm') || { textContent: '' }).textContent.replace(/\s+/g, ' ').trim();
      var items = [], ids = {};
      function push(url, label){
        if(!url) return;
        var id = driveId(url);
        if(ids[id]) return;              // 同じ写真は1回だけ
        ids[id] = 1;
        items.push({ big: driveSize(url, 1400), thumb: driveSize(url, 160), label: label || '' });
      }
      // 色見本があるならそれが本体。無い生地は代表写真だけ
      var sws = item.querySelectorAll('.sw');
      if(sws.length){
        [].forEach.call(sws, function(sw){
          var im = sw.querySelector('img'), sp = sw.querySelector('span');
          if(im) push(im.getAttribute('src'), sp ? sp.textContent.trim() : '');
        });
      } else {
        var head = item.querySelector('.fx-head .ph img');
        if(head) push(head.getAttribute('src'), '');
      }
      if(!items.length) return;

      /* 押した写真から開く。
         代表写真は色の並び順とは別に選んでいる（一覧が黒一色にならないようにするため）ので、
         **1枚目から開くのではなく、その写真が何番目かを探して合わせる。**
         合わせないと「水色を押したのに黒が出る」ことになる。 */
      var start = 0;
      var hit = e.target.closest('.sw') || e.target.closest('.fx-head');
      var im = hit && hit.querySelector('img');
      if(im){
        var id = driveId(im.getAttribute('src'));
        for(var i = 0; i < items.length; i++){ if(driveId(items[i].big) === id){ start = i; break; } }
      }
      if(openWith(items, start, name, '', item, 'fabric')) e.preventDefault();
    });
  }

  /* ---- 入り口3：お客様の声（2026-08-28 追加） ----
     一覧のカードは写真が小さく、コメントも枠に収めるため詰まって見える。
     タップしたら写真を大きく、コメントも全文そのまま読めるようにする（NAKさん指摘）。

     **1件ずつ開いて閉じる形にはしない。** 32件を1つの並びとして持たせ、
     開いたあとは左右・スワイプ・下のサムネイルで次の声へ移れる。
     写真もコメントも1件ごとに入れ替わる（show() 側で対応）。

     写真はページのHTMLに既に入っているものを使う（別データを持たない）。
     ?width=600 を差し替えるだけで大きい版・サムネイル版が取れる。 */
  if(hasReviews){
    var rvCards = [].slice.call(document.querySelectorAll('.review-cards .review-card'));
    var rvList = [];
    rvCards.forEach(function(c){
      var im = c.querySelector('.rv-photo img');
      if(!im) return;                       // 写真の無い声は拡大しても見るものが無い
      var src = im.getAttribute('src');
      var big = src.replace(/([?&])width=\d+/, '$1width=1400');
      var th  = src.replace(/([?&])width=\d+/, '$1width=160');
      var p   = c.querySelector('p');
      var who = c.querySelector('.who .txt');
      var st  = c.querySelector('.stars');
      c.setAttribute('data-rv', rvList.length);
      rvList.push({
        big: big, thumb: th, label: '',
        review: p   ? p.textContent.trim() : '',
        nm:     who ? who.textContent.replace(/\s+/g, ' ').trim() : '',
        stars:  st  ? st.textContent.trim() : ''
      });
    });

    if(rvList.length){
      document.addEventListener('click', function(e){
        var card = e.target.closest ? e.target.closest('.review-card[data-rv]') : null;
        if(!card) return;
        if(e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        var i = parseInt(card.getAttribute('data-rv'), 10);
        if(openWith(rvList, i, rvList[i].nm, '', card, 'review')) e.preventDefault();
      });
      // キーボードでも開けるようにする（カードは <a> ではないので自前で持たせる）
      rvCards.forEach(function(c){
        if(!c.hasAttribute('data-rv')) return;
        c.setAttribute('tabindex', '0');
        c.setAttribute('role', 'button');
        c.addEventListener('keydown', function(e){
          if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); c.click(); }
        });
      });
    }
  }

  /* ---- 入り口3b：各ページの「お客様の声」抜粋カードの写真（2026-10-22 NAKさん依頼） ----
     セミオーダー・フルオーダー・トップの「声」のカード（sections/nak-reviews.liquid の .rv-teaser）。
     写真の中に選手名・試合日・身長体重が入っているが、カードでは小さくて読めない。
     **写真だけ**をタップで拡大（本文を押したときの動きは今のまま＝何もしない）。
     お客様の声ページと違い、コメント欄は出さず写真を大きく出す（data-mode="rvphoto"）。
     同じセクションのカードを1つの並びにして、左右・スワイプ・サムネイルでめくれる。
     計測は review_photo_open / review_photo_view（お客様の声ページと同じ名前。製作事例の順位には混ぜない） */
  if(hasTeaser){
    [].slice.call(document.querySelectorAll('.rv-teaser')).forEach(function(wrap){
      var items = [], thumbs = [];
      [].slice.call(wrap.querySelectorAll('.review-card')).forEach(function(c){
        var th = c.querySelector('.who .thumb');
        var im = th && th.querySelector('img');
        if(!im) return;
        var src = im.getAttribute('src') || '';
        var who = c.querySelector('.who .txt');
        var idx = items.length;
        items.push({
          big:   /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=1400') : src,
          thumb: /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=160') : src,
          label: '', review: '', stars: '',
          nm: who ? who.textContent.replace(/\s+/g, ' ').trim() : ''
        });
        thumbs.push(th);
        th.setAttribute('role', 'button');
        th.setAttribute('tabindex', '0');
        th.setAttribute('aria-label', '写真を大きく見る');
        th.setAttribute('data-rvp', idx);
        /* 押せることは、写真の上ではなく名前の下の小さな「写真を拡大」で伝える
           （2026-10-22 NAKさん「虫めがねが重なって、拡大前の写真が見えない」） */
        if(who && !who.querySelector('.rvp-open')){
          var bt = document.createElement('button');
          bt.type = 'button'; bt.className = 'rvp-open'; bt.textContent = '写真を拡大';
          bt.setAttribute('data-rvp', idx);
          who.appendChild(bt);
          thumbs.push(bt);
        }
      });
      thumbs.forEach(function(th){
        var i = parseInt(th.getAttribute('data-rvp'), 10);
        th.addEventListener('click', function(e){
          if(e.metaKey || e.ctrlKey || e.shiftKey) return;
          if(openWith(items, i, items[i].nm, '', th, 'rvphoto')) e.preventDefault();
        });
        th.addEventListener('keydown', function(e){
          if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); th.click(); }
        });
      });
    });
  }

  /* ---- 入り口4：トップ等の抜粋グリッド（2026-09-03 追加） ----
     トップ・フルオーダーLP・どちらを選ぶか・Tシャツ・のぼり・持込 に置いている
     sections/nak-works.liquid のカード。
     それまでは押すと商品ページ（多くは「売り切れ」）へ飛んでいた。
     **トップはLINEクリックの46.6%を生む最重要ページ**で、そこから外へ送り出していた。
     製作事例ページと同じく、その場で拡大する形に揃える。
     <a href> は残してあるので、新しいタブ・長押し・JS無効では商品ページに着く。

     写真一覧は各セクションが持つ JSON（.works-grid の data-media が指すid）。
     生成は sections/nak-works.liquid。 */
  if(hasMini){
    var miniCache = {};
    function miniMedia(grid){
      var id = grid.getAttribute('data-media');
      if(!id) return null;
      if(miniCache[id] !== undefined) return miniCache[id];
      var el = document.getElementById(id);
      var v = null;
      if(el){ try { v = JSON.parse(el.textContent); } catch(e){ v = null; } }
      miniCache[id] = v;
      return v;
    }
    document.addEventListener('click', function(e){
      var card = e.target.closest ? e.target.closest('.work-card[data-m]') : null;
      if(!card) return;
      if(e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      var grid = card.closest('.works-grid');
      if(!grid) return;
      /* リンク先が商品ページでないカードは横取りしない。
         フルオーダーLP・どちらを選ぶかLP の8件は /pages/works（製作事例の一覧）への
         リンクで、ここを拡大に変えると「写真1枚だけ開いて一覧へ行けない」ことになる。
         2026-09-03、実装時に判明。仕様書は「商品以外もその場で拡大」としていたが、
         一覧への導線を壊すため**そのまま行かせる**を選んだ（NAKさんへ報告済み） */
      var pid = handleOf(card.getAttribute('href') || '');
      if(!pid) return;
      var media = miniMedia(grid);
      if(!media || !media.items) return;                    // JSONが無ければ従来どおり商品ページへ
      var srcs = media.items[parseInt(card.getAttribute('data-m'), 10)] || [];
      if(!srcs.length) return;
      var items = srcs.map(function(s){
        return {
          big:   s.replace(/([?&])width=\d+/, '$1width=1400'),
          thumb: s.replace(/([?&])width=\d+/, '$1width=160'),
          label: ''
        };
      });
      var nm = card.querySelector('.name'), mt = card.querySelector('.meta');
      var href = card.getAttribute('href') || '';
      if(openWith(items, 0, nm ? nm.textContent.trim() : '', mt ? mt.textContent.trim() : '',
                  card, 'works', pid, href)) {
        e.preventDefault();
      }
    });
  }

  /* ---- 事例カードが「見られた回数」を数える（2026-09-03 追加） ----
     並び順を数字で決めるために要る。**拡大された回数だけでは順位を作れない。**
     上にあるカードほど開かれる（1〜12番目は1件あたり月12.8回、97番目以降は0.8回）ので、
     回数そのままで並べ替えると今の上位が固定されるだけになる。
     「見られた回数あたり何回開かれたか」を出すために、分母をここで数える。

     ・製作事例ページ（/pages/works）だけ。抜粋グリッドは母数が偏るので数えない
     ・半分以上が1秒以上見えたら1回。スクロールで戻っても再送しない
     ・IntersectionObserver が無いブラウザでは何もしない（表示には影響させない） */
  if(hasWorks && typeof IntersectionObserver === 'function'){
    var cards = document.querySelectorAll('.works-grid .work-card[data-w]');
    if(cards.length){
      var timers = {}, counted = {};
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          var el = en.target, w = el.getAttribute('data-w');
          if(counted[w]) { io.unobserve(el); return; }
          if(en.isIntersecting){
            if(timers[w]) return;
            timers[w] = setTimeout(function(){
              timers[w] = null;
              if(counted[w]) return;
              counted[w] = 1;
              io.unobserve(el);
              var nm = el.querySelector('.name');
              var href = el.getAttribute('href') || '';
              track('work_card_view', {
                work_id: handleOf(href),
                work_name: nm ? nm.textContent.trim() : '',
                position: parseInt(w, 10) + 1
              });
            }, 1000);
          } else if(timers[w]){
            clearTimeout(timers[w]); timers[w] = null;   // 通り過ぎただけは数えない
          }
        });
      }, { threshold: 0.5 });
      [].forEach.call(cards, function(el){ io.observe(el); });
    }
  }

  /* 製作事例ページの「倉庫」を開く（2026-10-08 Phase 2）
     49件目からは閉じてある。ボタンは /pages/works#works-all へのリンクなので
     internal_nav_click で押された回数が数えられる（新しいイベントは送らない）。
     倉庫のカードは最初から observe してあるので、開いて画面に入れば work_card_view が出る。
     #works-all 付きで来た人（共有・戻る）には最初から開いて見せる */
  var archive = document.getElementById('works-all');
  if(archive){
    var openArchive = function(){
      archive.hidden = false;
      var more = document.querySelector('.works-more');
      if(more) more.hidden = true;
    };
    document.querySelectorAll('[data-works-more]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        if(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;   // 新しいタブは邪魔しない
        e.preventDefault();
        openArchive();
        archive.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    if(location.hash === '#works-all') openArchive();
  }
})();

/* 生地一覧に「その生地を名指しで」飛んできたときの受け口（2026-08-02）
   ------------------------------------------------------------------
   トップなどの生地タイルから /pages/fabrics#f-エナメル の形で飛んでくる。
   一覧は149銘柄あるので、位置に移動するだけでは埋もれて見つけられない。
   **その生地の色を開いて、少しの間だけ光らせる。**

   ・目印（id）は scripts/build-fabric-explorer.js が生地名から作っている
   ・目印が見つからないときは何もしない（生地名が変わってリンクが切れても、
     ページ自体は普通に開く）
   ------------------------------------------------------------------ */
(function(){
  function openFromHash(){
    var h = decodeURIComponent(window.location.hash || '').replace(/^#/, '');
    if(!h || h.indexOf('f-') !== 0) return;
    var item = document.getElementById(h);
    if(!item) return;                       // リンク切れ。何もしない

    // 色の一覧を開く
    var btn = item.querySelector('.fx-toggle');
    if(btn && btn.getAttribute('aria-expanded') !== 'true') btn.click();

    /* ヘッダーに隠れないよう、少し上に余裕をとって移動する。
       **1回では合わない。** 上にある写真が遅れて読み込まれると高さが変わり、
       狙った生地が画面の上に押し出される（実測で41pxずれた）。
       読み込みが落ち着くタイミングで数回やり直す。 */
    function goTo(){
      var y = item.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
    goTo();
    setTimeout(goTo, 400);
    setTimeout(goTo, 1200);
    window.addEventListener('load', function(){ setTimeout(goTo, 200); }, { once: true });

    // どれを指しているかが分かるように、少しの間だけ枠を光らせる
    item.classList.add('fx-target');
    setTimeout(function(){ item.classList.remove('fx-target'); }, 2600);
  }

  if(!document.querySelector('.fx-item')) return;   // 生地一覧ページ以外では何もしない
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openFromHash);
  else openFromHash();
  // 同じページ内でリンクを踏み直したときにも効かせる
  window.addEventListener('hashchange', openFromHash);
})();

/* ------------------------------------------------------------------
   生地一覧：制作事例から戻ってきたときに、見ていた状態を復元する（2026-08-03）

   GA4の実測で、このページに来た人は**1回の訪問で平均16個の生地を開いて
   比べている**（色を見る 82回 / 5人）ことが分かった。
   事例のパンツを見に行って戻ると、開いていたものが全部閉じてしまい、
   16個ぶんの操作がやり直しになる。それを避けるための復元。

   ・復元するのは「事例のパンツを見に行って戻ってきたとき」だけ。
     メニューから普通に開いたときは、まっさらな状態で始まる
   ・目印は、事例をクリックした瞬間にsessionStorageへ置くフラグ。
     30分を過ぎたものは無視する（別の用事で戻ってきた場合）
   ・戻す位置は「見ていた生地」に合わせる。スクロール量そのものだと、
     写真の読み込みで高さが変わってずれる
   ------------------------------------------------------------------ */
(function(){
  if(!document.querySelector('.fx-item')) return;
  var KEY = 'nak-fx-state';
  var MAX_AGE = 30 * 60 * 1000;
  var restoring = false;

  function save(fromId){
    try{
      var s = { t: Date.now(), from: fromId || '', c: [], w: [], a: [], m: '' };
      Array.prototype.forEach.call(document.querySelectorAll('.fx-item'), function(it){
        if(!it.id) return;
        var col = it.querySelector('.fx-colors'), wk = it.querySelector('.fx-works');
        if(col && !col.hasAttribute('hidden')) s.c.push(it.id);
        if(wk && !wk.hasAttribute('hidden')) s.w.push(it.id);
        if(wk && wk.classList.contains('fx-all')) s.a.push(it.id);
      });
      var on = document.querySelector('.fx-filter .fxf.on');
      if(on) s.m = on.getAttribute('data-motif') || '';
      var q = document.querySelector('.fx-search input');
      if(q && q.value) s.q = q.value;
      sessionStorage.setItem(KEY, JSON.stringify(s));
    }catch(e){ /* プライベートモード等。復元できなくても表示は壊さない */ }
  }

  // 事例のパンツを開いた＝戻ってくる可能性が高い。このときだけ印を残す
  document.addEventListener('click', function(e){
    if(!e.target.closest) return;
    var w = e.target.closest('.fx-work');
    if(!w) return;
    var it = w.closest('.fx-item');
    save(it ? it.id : '');
  });

  function restore(){
    var s = null;
    try{ s = JSON.parse(sessionStorage.getItem(KEY) || 'null'); }catch(e){}
    try{ sessionStorage.removeItem(KEY); }catch(e){}
    if(!s || !s.from || (Date.now() - s.t) > MAX_AGE) return;

    restoring = true;
    /* 探した言葉と柄の絞り込みは同時に効かないので、戻すのもどちらか一方。
       言葉のほうが後から使われたものなので、そちらを優先する */
    if(s.q && window.nakFxSearch){
      window.nakFxSearch(s.q);
    }else if(s.m){
      var f = document.querySelector('.fx-filter .fxf[data-motif="' + s.m + '"]');
      if(f && !f.classList.contains('on')) f.click();
    }
    function click(ids, sel, cond){
      (ids || []).forEach(function(id){
        var it = document.getElementById(id);
        var b = it && it.querySelector(sel);
        if(b && cond(b)) b.click();
      });
    }
    click(s.c, '.fx-toggle',  function(b){ return b.getAttribute('aria-expanded') !== 'true'; });
    click(s.w, '.fx-wtoggle', function(b){ return b.getAttribute('aria-expanded') !== 'true'; });
    click(s.a, '.fx-wmore',   function(b){ return !b.hidden; });
    restoring = false;

    // 見ていた生地に位置を合わせる。写真の読み込みで高さが変わるので数回やり直す
    var item = document.getElementById(s.from);
    if(!item) return;
    function goTo(){
      window.scrollTo(0, item.getBoundingClientRect().top + window.scrollY - 90);
    }
    goTo();
    setTimeout(goTo, 300);
    setTimeout(goTo, 900);
    window.addEventListener('load', function(){ setTimeout(goTo, 200); }, { once: true });
  }

  // 柄の絞り込みは押すと区分の先頭までスクロールする。復元中はそれを邪魔させない
  window.nakFxRestoring = function(){ return restoring; };

  /* ブラウザによっては「戻る」でページをそのまま出す（開いた状態が残る）。
     そのときは復元が不要なので、残っている印を捨てる。
     捨てておかないと、あとで再読み込みしたときに勝手に開き直してしまう */
  window.addEventListener('pageshow', function(e){
    if(e.persisted){ try{ sessionStorage.removeItem(KEY); }catch(err){} }
  });

  // ハッシュ付きで開いたときは、そちらの移動を優先する（復元しない）
  if(!window.location.hash){
    if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restore);
    else restore();
  }
})();

/* 商品ページ：その商品（選手）に届いたレビューを、値段のすぐ下に出す（2026-10-08）
   ------------------------------------------------------------------
   Judge.me のレビュー欄は注文ボタンから画面2つ分ほど下にあり、見られないまま帰る人が多い。
   レビューの研究では「写真の次に見られるのがレビュー」なので、商品名・値段の近くに一言だけ出し、
   押すとレビュー欄（#judgeme_product_reviews）へ移る。中身は Judge.me がページに書き出した
   レビューをそのまま読む（文章は書き換えない。長いときは途中まで）。レビューが無い商品では何も出さない。
   計測：表示 review_own_view／押下 review_own_click（snippets/nak-analytics.liquid） */
(function(){
  if(!document.body || !document.body.classList.contains('template-product')) return;
  var widget = document.querySelector('.jdgm-review-widget');
  if(!widget) return;
  var revs = widget.querySelectorAll('.jdgm-rev');
  if(!revs.length) return;
  var r = revs[0];
  var bodyEl = r.querySelector('.jdgm-rev__body');
  var text = bodyEl ? bodyEl.textContent.replace(/\s+/g, ' ').trim() : '';
  if(text.length < 8) return;
  var rating = r.querySelector('[data-score]');
  var score = rating ? parseInt(rating.getAttribute('data-score'), 10) || 5 : 5;

  // 途中までにするときは、なるべく文の切れ目で切る
  var MAX = 72, quote = text;
  if(text.length > MAX){
    var cut = text.slice(0, MAX);
    var end = Math.max(cut.lastIndexOf('。'), cut.lastIndexOf('！'), cut.lastIndexOf('!'));
    quote = (end >= 24 ? cut.slice(0, end + 1) : cut) + '…';
  }
  var titleEl = document.querySelector('.product__title');
  var title = titleEl ? titleEl.textContent : '';
  // 件数は Judge.me の総数を使う（ページに出ているのは最初の5件だけのことがある）
  var totalEl = widget.querySelector('[data-number-of-reviews]') || document.querySelector('[data-number-of-reviews]');
  var total = totalEl ? parseInt(totalEl.getAttribute('data-number-of-reviews'), 10) || revs.length : revs.length;
  var label = total > 1 ? 'お客様のレビュー（' + total + '件）'
            : (/選手/.test(title) ? 'この選手からのレビュー' : 'この商品のレビュー');

  var a = document.createElement('a');
  a.className = 'own-review';
  a.href = '#judgeme_product_reviews';
  a.setAttribute('data-own-review', '');
  a.setAttribute('data-own-review-link', '');
  var head = document.createElement('span'); head.className = 'own-review__head';
  var st = document.createElement('span'); st.className = 'own-review__stars';
  st.textContent = '★★★★★'.slice(0, score) + '☆☆☆☆☆'.slice(0, 5 - score);
  st.setAttribute('aria-label', '星' + score);
  var lb = document.createElement('span'); lb.className = 'own-review__label'; lb.textContent = label;
  head.appendChild(st); head.appendChild(lb);
  var q = document.createElement('span'); q.className = 'own-review__quote'; q.textContent = '「' + quote + '」';
  var more = document.createElement('span'); more.className = 'own-review__more'; more.textContent = 'レビューを読む';
  a.appendChild(head); a.appendChild(q); a.appendChild(more);

  // 値段のすぐ下。見つからなければ商品名の下
  var price = document.querySelector('[id^="price-template"]');
  var anchor = price || titleEl;
  if(!anchor || !anchor.parentNode) return;
  anchor.parentNode.insertBefore(a, anchor.nextSibling);
})();

/* お客様の声ページ：種類の切り替え・話題の絞り込み・途中のLINEボタン（2026-10-08）
   ------------------------------------------------------------------
   カードは scripts/build-reviews.js が全部HTMLに入れておく（data-kind / data-tags 付き）。ここでは出し入れだけ。
   最初はフルオーダー（注文が一番多い）。#semi / #full / #bring / #all で来たらその種類で開く
   （セミオーダーのページの「すべて見る」は #semi で来る）。
   LINEボタンは、絞り込んだあとの並びで10件ごとに入れ直す（#rv-cta-tpl を複製）。JSが切れていれば全件がそのまま出る */
(function(){
  var list = document.querySelector('[data-rv-list]');
  if(!list) return;
  var cards = [].slice.call(list.querySelectorAll('.review-card'));
  var tabs = [].slice.call(document.querySelectorAll('.rv-tab'));
  var chips = [].slice.call(document.querySelectorAll('.rv-chip'));
  var empty = document.querySelector('.rv-empty');
  var tpl = document.getElementById('rv-cta-tpl');
  var every = parseInt(list.getAttribute('data-cta-every'), 10) || 10;
  var kinds = tabs.map(function(t){ return t.getAttribute('data-kind'); });
  var state = { kind: 'full', topic: '' };
  var h = (location.hash || '').replace('#', '');
  if(kinds.indexOf(h) >= 0) state.kind = h;

  function match(c, kind, topic){
    if(kind !== 'all' && c.getAttribute('data-kind') !== kind) return false;
    return !topic || (' ' + (c.getAttribute('data-tags') || '') + ' ').indexOf(' ' + topic + ' ') >= 0;
  }
  function apply(){
    [].forEach.call(list.querySelectorAll('.rv-inline-cta'), function(x){ x.parentNode.removeChild(x); });
    var shown = 0;
    cards.forEach(function(c){
      var ok = match(c, state.kind, state.topic);
      c.hidden = !ok;
      if(ok){
        shown++;
        if(tpl && tpl.content && shown % every === 0){
          c.parentNode.insertBefore(tpl.content.firstElementChild.cloneNode(true), c.nextSibling);
        }
      }
    });
    if(empty) empty.hidden = shown > 0;
    tabs.forEach(function(t){
      var on = t.getAttribute('data-kind') === state.kind;
      t.classList.toggle('on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    chips.forEach(function(ch){
      var tp = ch.getAttribute('data-topic');
      ch.classList.toggle('on', tp === state.topic);
      if(!tp) return;
      var n = cards.filter(function(c){ return match(c, state.kind, tp); }).length;
      var sp = ch.querySelector('span'); if(sp) sp.textContent = n;
      ch.disabled = n === 0;
    });
  }
  tabs.forEach(function(t){
    t.addEventListener('click', function(){
      state.kind = t.getAttribute('data-kind');
      // 切り替えた先で0件になる話題は外す
      if(state.topic && !cards.some(function(c){ return match(c, state.kind, state.topic); })) state.topic = '';
      apply();
      try{ history.replaceState(null, '', '#' + state.kind); }catch(e){}
    });
  });
  chips.forEach(function(ch){
    ch.addEventListener('click', function(){ state.topic = ch.getAttribute('data-topic') || ''; apply(); });
  });
  apply();
})();

/* セミオーダーのサイズの目安（2026-10-12）
   ------------------------------------------------------------------
   sections/nak-size-helper.liquid の data-chart（商品写真のサイズ表と同じ数字）を使う。
   [サイズ, 目安体重の下限, 上限, ウエストの下限, 上限, 総丈]（0 はサイズ表に数字が無い）
   ・体重が「下限 < 体重 ≦ 上限」に入るサイズを目安にする。境目から2kg以内なら隣のサイズも出す
   ・ウエストを入れたら、そのサイズのウエストの幅に入るかを確かめる。入らなければ入るサイズを出す
   ・LINEのボタンは、入れた内容が入った状態で開く（oaMessage・@280migxa）
   計測：size_helper_result（目安が出た・1回だけ）。LINEの押下は既存の line_button_click に乗る */
(function(){
  var box = document.querySelector('[data-size-helper]');
  if(!box) return;
  var chart; try { chart = JSON.parse(box.getAttribute('data-chart')); } catch(e) { return; }
  var w = box.querySelector('.sz-w'), wa = box.querySelector('.sz-waist'), h = box.querySelector('.sz-h');
  var empty = box.querySelector('.size-out__empty'), res = box.querySelector('.size-out__res');
  var out = function(k){ return box.querySelector('[data-out="' + k + '"]'); };
  var line = box.querySelector('[data-size-line]');
  var LINE_ID = '@280migxa';
  var tracked = false;

  function num(el){ var v = parseFloat(el && el.value); return isNaN(v) ? null : v; }
  function lenOf(){ var r = box.querySelector('input[name^="sz-len"]:checked'); return r ? r.value : 'short'; }

  function pick(rows, kg){
    for(var i = 0; i < rows.length; i++){ if(kg > rows[i][1] && kg <= rows[i][2]) return i; }
    if(kg <= rows[0][1]) return -1;               // いちばん小さいサイズより軽い
    return rows.length;                           // いちばん大きいサイズより重い
  }

  function run(){
    var len = lenOf(), rows = chart[len], kg = num(w), waist = num(wa), cm = num(h);
    var lenJ = len === 'short' ? 'ショート丈' : 'ミドル丈';
    var size = '', why = '', note = '', spec = '';
    if(kg === null){
      empty.hidden = false; res.hidden = true; size = '';
    } else {
      empty.hidden = true; res.hidden = false;
      var i = pick(rows, kg);
      if(i < 0){
        size = len === 'short' ? rows[0][0] : '—';
        why = len === 'short' ? 'いちばん小さい' + rows[0][0] + 'の目安（' + rows[0][2] + 'kgまで）です。'
                              : 'ミドル丈はSサイズ（' + rows[0][1] + 'kg〜）からです。ショート丈なら、もっと小さいサイズがあります。';
        if(len !== 'short'){ note = '丈をショート丈に切り替えると、目安が出ます。'; }
      } else if(i >= rows.length){
        size = len === 'short' ? rows[rows.length - 1][0] : '—';
        why = len === 'short' ? 'いちばん大きい' + rows[rows.length - 1][0] + 'の目安（' + rows[rows.length - 1][1] + 'kg〜）です。'
                              : 'ミドル丈はXLサイズ（' + rows[rows.length - 1][2] + 'kgまで）までです。ショート丈ならXXL・XXXLがあります。';
        if(len !== 'short'){ note = '丈をショート丈に切り替えると、目安が出ます。'; }
      } else {
        var r = rows[i];
        size = r[0];
        var range = !r[1] ? r[2] + 'kgまで' : (r[2] >= 200 ? r[1] + 'kg〜' : r[1] + '〜' + r[2] + 'kg');
        why = r[0] + 'の目安体重は' + range + 'です。';
        // 境目に近いときは、隣のサイズも
        var near = [];
        if(i > 0 && kg - r[1] <= 2) near.push(rows[i - 1][0]);
        if(i < rows.length - 1 && r[2] - kg <= 2) near.push(rows[i + 1][0]);
        if(near.length){
          var both = near.concat(r[0]).sort(function(a, b){ return rows.map(function(x){ return x[0]; }).indexOf(a) - rows.map(function(x){ return x[0]; }).indexOf(b); });
          note = '境目に近いので、' + both.join('と') + 'で迷うかもしれません。身長と一緒にLINEでご相談ください。';
        }
        // ウエストの確かめ
        if(waist !== null && r[3]){
          if(waist < r[3] || waist > r[4]){
            var fit = rows.filter(function(x){ return x[3] && waist >= x[3] && waist <= x[4]; }).map(function(x){ return x[0]; });
            note = 'ウエスト' + waist + 'cmは、' + r[0] + '（' + r[3] + '〜' + r[4] + 'cm）の幅から外れています。' +
                   (fit.length ? 'ウエストで選ぶと ' + fit.join('・') + ' です。' : '') + 'どちらにするか、LINEでご相談ください。';
          } else if(!note){
            note = 'ウエスト' + waist + 'cmも、' + r[0] + 'の幅（' + r[3] + '〜' + r[4] + 'cm）に入っています。';
          }
        }
        if(r[3]) spec = '<div class="q-line"><dt>ウエスト（ゴム）</dt><dd>' + r[3] + '〜' + r[4] + 'cm</dd></div>' +
                        '<div class="q-line"><dt>総丈</dt><dd>' + r[5] + 'cm</dd></div>';
      }
      out('size').textContent = size || '—';
      out('why').textContent = why;
      out('note').textContent = note;
      out('spec').innerHTML = spec;
      if(!tracked && size && size !== '—' && typeof gtag === 'function'){
        tracked = true;
        try { gtag('event', 'size_helper_result', { length: len, size: size }); } catch(e) {}
      }
    }
    // LINEのボタン：入れた内容が入った状態で開く
    var msg = 'セミオーダーのサイズの相談です。\n丈：' + lenJ +
      (cm !== null ? '\n身長：' + cm + 'cm' : '') + (kg !== null ? '\n体重：' + kg + 'kg' : '') +
      (waist !== null ? '\nウエスト：' + waist + 'cm' : '') + (size && size !== '—' ? '\nサイズの目安：' + size : '');
    if(line) line.href = 'https://line.me/R/oaMessage/' + LINE_ID + '/?' + encodeURIComponent(msg);
  }
  box.addEventListener('change', run);
  box.addEventListener('input', run);
  run();
})();

/* オーダーの見積もり（フル・セミ）→ そのままLINEで相談（2026-10-12・sections/nak-estimator.liquid）
   ------------------------------------------------------------------
   2026-10-21 NAKさん指示で「簡易見積もり」に作り直し：
   ・入れるのはスポンサー・ロゴの「数」だけ（大きさ別・画像の数は聞かない）
   ・込みの社数（data-incl）を超えた分は、すべて「20cm以内」で計算し、1枚ごとに縫い付け（data-sew）を足す
   ・画像指定（data-img）は、追加分が「全部文字だけ」〜「全部画像」の幅にして、合計を「〜」で出す
   金額はすべて liquid の data 属性から受け取る（ここに数字は書かない。価格改定はテーマエディタで済む）。
   単価と数え方は受注管理（quote.ts／quote.py）と同じ。
   LINEのボタンは、選んだ内容と見積もりが入った状態で開く（oaMessage）。
   計測：estimator_use（初めて数字を動かした）。LINEの押下は line_button_click と line_click_estimate */
(function(){
  document.querySelectorAll('[data-estimator]').forEach(function(box){
    var d = function(k){ return parseInt(box.getAttribute('data-' + k), 10) || 0; };
    var yen = function(n){ return n.toLocaleString('ja-JP') + '円'; };
    var KIND = { full: 'フルオーダー', short: 'セミオーダー ショート丈', middle: 'セミオーダー ミドル丈' };
    var lineBtn = box.querySelector('[data-estimate-line]');
    var used = false;

    function count(key){
      var el = box.querySelector('[data-count="' + key + '"] .q-num');
      var v = el ? parseInt(el.value, 10) : 0;
      return isNaN(v) || v < 0 ? 0 : v;
    }
    function val(sel){ var el = box.querySelector(sel); return el ? (el.value || '').trim() : ''; }

    function run(){
      var kr = box.querySelector('input[name^="es-kind"]:checked');
      var kind = kr ? kr.value : 'full';
      var base = d(kind), incl = d('incl');
      var logos = count('logos'), own = count('own');
      var extra = Math.max(0, logos - incl);

      var lines = [];   // [名前, 単価, 数]
      if(extra) lines.push(['追加のロゴ（20cm以内で計算）', d('a20'), extra]);
      if(extra + own) lines.push(['縫い付け', d('sew'), extra + own]);
      var low = base;
      lines.forEach(function(l){ low += l[1] * l[2]; });
      var high = low + d('img') * extra;     // 追加分を全部画像でいただいた場合

      // 画面の内訳
      var html = '<div class="q-line"><dt>' + KIND[kind] + '（カスタマイズセット・スポンサー' + incl + '社まで込み）</dt><dd>' + yen(base) + '</dd></div>';
      lines.forEach(function(l){
        html += '<div class="q-line"><dt>' + l[0] + '</dt><dd>' + yen(l[1]) + ' × ' + l[2] + ' ＝ ' + yen(l[1] * l[2]) + '</dd></div>';
      });
      if(extra) html += '<div class="q-line"><dt>ロゴを画像でいただく場合</dt><dd>0〜' + yen(d('img') * extra) + '</dd></div>';
      box.querySelector('[data-out="lines"]').innerHTML = html;
      var range = low === high ? '¥' + low.toLocaleString('ja-JP')
                               : '¥' + low.toLocaleString('ja-JP') + '〜' + high.toLocaleString('ja-JP');
      box.querySelector('[data-out="total"]').textContent = range;

      // LINEに入れる文（NAKさんの【お見積り】の形）
      var msg = ['かんたん見積もりから相談です。', '', '【お見積り（サイトの目安）】', 'カスタマイズセット', KIND[kind] + ' ' + yen(base)];
      if(lines.length){ msg.push('追加カスタマイズ'); lines.forEach(function(l){ msg.push(l[0] + ' ' + yen(l[1]) + ' x ' + l[2]); }); }
      if(extra) msg.push('画像指定 0〜' + yen(d('img') * extra));
      msg.push('ーーーーーーーーーー', '合計 ' + (low === high ? yen(low) : low.toLocaleString('ja-JP') + '〜' + yen(high)), '※送料別途', '');
      if(logos) msg.push('スポンサー・ロゴ：' + logos + '個');
      if(own) msg.push('持っているワッペン：' + own + '枚');
      var date = val('.es-date'), fabric = val('.es-fabric'), size = val('.es-size'), memo = val('.es-memo');
      if(date) msg.push('試合の日：' + date);
      if(fabric) msg.push('生地・色の希望：' + fabric);
      if(size) msg.push('サイズ・体格：' + size);
      if(memo) msg.push('ひとこと：' + memo);
      var id = box.getAttribute('data-line') || '@280migxa';
      if(lineBtn) lineBtn.href = 'https://line.me/R/oaMessage/' + id + '/?' + encodeURIComponent(msg.join('\n'));

      // 選択中の見た目（:has() が使えない端末向け）
      box.querySelectorAll('.q-opt').forEach(function(lab){ var i = lab.querySelector('input'); lab.classList.toggle('on', !!(i && i.checked)); });
    }

    function touched(){
      if(used || typeof gtag !== 'function') return;
      used = true;
      try { gtag('event', 'estimator_use', { page_path: location.pathname }); } catch(e) {}
    }
    box.querySelectorAll('.q-step').forEach(function(btn){
      btn.addEventListener('click', function(){
        var inp = btn.parentNode.querySelector('.q-num');
        var v = (parseInt(inp.value, 10) || 0) + parseInt(btn.getAttribute('data-step'), 10);
        var max = parseInt(inp.getAttribute('max'), 10) || 99;
        inp.value = Math.min(max, Math.max(0, v));
        touched(); run();
      });
    });
    box.addEventListener('change', function(){ touched(); run(); });
    box.addEventListener('input', run);
    run();
  });
})();
